import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { FreePickerText, FreePickerWrapper } from '../../styled';

interface PickFreeProductCardProps {
  clickHandler: () => void;
}

const PickFreeProductCard = ({ clickHandler }: PickFreeProductCardProps) => {
  const { freeSampleData } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );

  const cartFreeGiftBanner =
    useSelector(
      (state: State) => state.remoteConfig.configs.cartFreeGiftBanner
    ) || {};
  const { freeSampleMessage } = freeSampleData || {};

  if (!freeSampleMessage) {
    return null;
  }

  return (
    <FreePickerWrapper
      data-test-id="pick_free_samples_card"
      onClick={clickHandler}
      cartFreeGiftBanner={cartFreeGiftBanner}
    >
      {freeSampleMessage && (
        <FreePickerText>{freeSampleMessage}</FreePickerText>
      )}
    </FreePickerWrapper>
  );
};

export default PickFreeProductCard;
